import axios from "@/utils/request";
import request from '@/utils/request'

export function getAxiosOption(data, params, config) {
  return axios
    .get(`/productComment/web/praise`, { params })
    .then(res => res.data);
}

export function getListResourceInfo(data = {}, params) {
  return axios
    .get(`/productResource/web/listResourceInfo`, { params })
    .then(res => res.data);
}

export function getFindByCodeInfo(data = {}, params) {
  return axios
    .post(`/product/web/findByCode`, data, { params })
    .then(res => res.data);
}
export function vxShare(data = {}, params) {
  return axios
    .post(`/thildlogin/getVxShareSign`, data, { params })
    .then(res => res.data);
}
//用户评价
export function getUserCommont(data = {}, params) {
  return axios
    .get(`/productComment/web/page`, { params })
    .then(res => res.data);
}
//目录数据
export function getResCatalogs(data = {}, params) {
  return axios
    .get(`/resource/web/resCatalogs`, { params })
    .then(res => res.data);
}
//pdf目录数据
export function getResCatalogsPDF(data = {}, params) {
  return axios
    .get(`/resource/web/pdfResCatalogs`, { params })
    .then(res => res.data);
}
//我的足迹
export function getBrowseRecord(data = {}, params) {
  return axios.get(`/browseRecord/web/page`, { params }).then(res => res.data);
}
//相关推荐
export function getProductRecomList(data = {}, params) {
  return axios
    .get(`/productRecom/web/productRecomList`, { params })
    .then(res => res.data);
}

//加入购物车
export function addShoppingCart(data = {}, params) {
  return axios.post(`/shoppingCart/web/save`, data).then(res => res.data);
}

//微信参数请求
export function wxMiniPay(data = {}, params) {
  return axios
    .post(`/onlinePay/web/wxMiniPay`, data, {
      params
    })
    .then(res => res.data);
}

//更新收货地址
export function updateByAddressId(data = {}, params) {
  return axios
    .post(`/UserAddress/updateByAddressId`, data, {
      params
    })
    .then(res => res.data);
}

//设置默认收货地址
export function UserAddressDefault(data = {}, params) {
  return axios
    .post(`/UserAddress/isDefault`, data, {
      params
    })
    .then(res => res.data);
}
//查询收货地址信息
export function selectUserAddressByAddressID(data = {}, params) {
  return axios
    .post(`/UserAddress/selectUserAddressByAddressID`, data, {
      params
    })
    .then(res => res.data);
}
//删除收货地址
export function delectUserAddressByAddressId(data = {}, params) {
  return axios
    .post(`/UserAddress/delectUserAddressByAddressId`, data, { params })
    .then(res => res.data);
}

//获取城市数据
export function selectRegion(data = {}, params) {
  return axios
    .post(`/region/selectRegion`, data, { params })
    .then(res => res.data);
}

//获取用户城市地址
export function findRegion(data = {}, params) {
  return axios
    .post(`/region/findRegion`, data, { params })
    .then(res => res.data);
}

//获取商品圈子列表
export function circlePage(data = {}, params) {
  return axios
    .post(`/circle/web/circleByCode`, data, { params })
    .then(res => res.data);
}
// circleList

//圈子邀请码加入请求
export function joinCircle(data = {}, params) {
  return axios
    .post(`/inviteCode/web/exchange`, data, { params })
    .then(res => res.data);
}

//用户收藏/取消收藏
export function collectProductAsyncSend(data = {}, params) {
  return axios
    .post(`/collectProduct/web/asyncSend`, data, { params })
    .then(res => res.data);
}

//商品关联增值包
export function productPackageWebPage(data = {}, params) {
  //分页
  // return axios.post(`/productPackage/web/page`,data, { params }).then(res => res.data)
  //不分页
  return axios
    .post(`/productPackage/web/list`, data, { params })
    .then(res => res.data);
}

//课件下载请求
export function resourceDownload(data = {}, params) {
  return axios.get(`/resource/web/download`, { params }).then(res => res.data);
}

//搜索资源

export function searchGroupResource(data = {}, params) {
  return axios
    .post(`/search/web/searchGroupResResource`, data, { params })
    .then(res => res.data);
}

//h5搜索分类数据获取
export function getSaleClass(params) {
  return axios.get(`/saleClass/list`, { params }).then(res => res.data);
}

//热词搜索
export function getHotKeyWords(params) {
  return axios.get(`/searchLog/hotKeyWords`, { params }).then(res => res.data);
}



//签到
export function getSignIn(data,params){
  return axios.post(`/userAccumulate/web/signIn`,data,{params}).then(res=>res.data)
}
//用户获取积分以及今日积分任务完成记录
export function getUserAccounment(data,params){
  return axios.post(`/userAccumulate/web/findByToken`,data,{params}).then(res=>res.data)
}
//baner图
export function getBannerFindListByCode(data,params){
  return axios.get(`/banner/findListByCode`,{params}).then(res=> res.data)
}

//专题库
export function getModuleProducts(data,params){
  return axios.post(`/product/web/moduleProducts`,data,{params}).then(res => res.data)
}

export function getWebPageIndexProduct(data,params){
  return axios.post(`/product/web/PageIndexProduct`,data,{params}).then(res => res.data)
}

export function getReaderRecommendation(data,params){
  return axios.post(`/recommend/web/allPageList`,data,{params}).then(res => res.data)
}

export function getReaderList(data,params){
  return axios.post(`/product/web/readCountList`,data,{params}).then(res => res.data)
}

// getNetTime.js
 
export function getTime() {
  return new Promise((resolve) => {
    const xhr = new window.XMLHttpRequest;
    xhr.responseType = "document";
    // 通过get的方式请求当前文件
    xhr.open("head", location.href);
    // xhr.send(null);
    // 监听请求状态变化
    xhr.onreadystatechange = function () {
      var time = null;
      if (xhr.readyState === 2) {
        // 获取响应头里的时间戳
        time = xhr.getResponseHeader("Date");
        time = time ? new Date(time) : new Date();
        resolve(time);
      }
    };

    setTimeout(function () {
      resolve(new Date());
    }, 2000);
  });
}


// 我的荐购
export function myRecommend (params,data) {
  return request({
    url: '/recommend/web/pageList',
    method: 'post',
    params: params,
    data: data
  })
}
// 资源列表分页
export function resoucePage (params,data) {
  return request({
    url: '/productResource/web/pageProducResource',
    method: 'post',
    params: params,
    data: data
  })
}
// 获取资源类型列表
export function resouceTypeList (params) {
  return request({
    url: '/productResource/web/categoryNum',
    method: 'get',
    params: params,
  })
}
// 商品荐购是否展示
export function getRecommendAuth (params) {
  return request({
    url: '/product/web/getRecommendAuth',
    method: 'post',
    params: params
  })
}

// 新增荐购商品
export function addRecommend (params,data) {
  return request({
    url: '/recommend/web/save',
    method: 'post',
    params: params,
    data: data
  })
}

// 荐购品类列表
export function myCategoryList (params) {
  return request({
    url: '/recommend/web/myCategoryList',
    method: 'get',
    params: params
  })
}

// 获取阅读权限
export function getAuth (params) {
  return request({
    url: '/product/web/getAuth',
    method: 'post',
    params: params
  })
}
// product/web/getAuth


// 机构建购商品人数
export function getRecPerson (params) {
  return request({
    url: '/recommend/web/recommendPersonList',
    method: 'get',
    params: params
  })
}

// 判断是否机构用户
export function getBranch (params) {
  return request({
    url: '/zaBranch/web/findByToken',
    method: 'post',
    params: params
  })
}

// 添加用户访问日志

export function asyncSave (params,data) {
  return request({
    url: '/visitLog/web/asyncSave',
    method: 'post',
    params: params,
    data: data
  })
}
// 添加用户访问日志

export function getSaleClassProducts (params,data) {
  return request({
    url: '/product/web/saleClassProducts',
    method: 'post',
    params: params,
  })
  // 课程目录
}
export function getResourceAffiliate (params) {
  return request({
    url: '/resourceAffiliate/web/list',
    method: 'get',
    params: params,
  })
}

// 搜索记录
export function getHistoryList(params){
  return axios.get(`/searchLog/web/pageUserSearch`,params).then(res => res.data)
}
// export function getHistoryList(params){
//   return request({
//     url: '/searchLog/web/pageUserSearch',
//     method: 'get',
//     params: params,
//   })
// }


// WEBPACK FOOTER //
// ./src/api/szts.js